import React from "react";

import "../styles/team.css";

import ignasPic from "./pics/Ignas.jpg";
import matasPic from "./pics/Matas.jpg";
import vitalijaPic from "./pics/Vitalija.jpg";
import pijusPic from "./pics/Pijus.jpg";
import jonasPic from "./pics/Jonas.jpg";
import dominykasPic from "./pics/Dominykas.jpg";

import { ifMobile } from "../App";

const teamMembers = [
    {
        name: "Ignas Mikolaitis",
        position: "Software Engineer",
        img: ignasPic,
        socials: {
            linkedin: "https://www.linkedin.com/in/ignas-mikolaitis/",
            facebook: "https://www.facebook.com/ignuxas/",
            website: "https://ignuxas.com"
        }
    },
    {
        name: "Matas Širvys",
        position: "Sales",
        img: matasPic,
        socials: {
            linkedin: "https://www.linkedin.com/in/matas-%C5%A1irvys-114aa22bb/",
            facebook: "https://www.facebook.com/matas.sirvys.1",
        }
    },
    {
        name: "Vitalija Venckuvienė",
        position: "Mentor",
        img: vitalijaPic,
        socials: {
            linkedin: "https://www.linkedin.com/in/vitalija-venckuvien%C4%97-58baa4106/",
        }
    },
    {
        name: "Pijus Balčaitis",
        position: "Marketing",
        img: pijusPic,
        socials: {
            facebook: "https://www.facebook.com/profile.php?id=100012462394407",
        }
    },
    {
        name: "Jonas Drąsutavičius",
        position: "Sales",
        img: jonasPic,
        socials: {
            facebook: "https://www.facebook.com/jonas.drasutavicius.3",
        }
    },
    {
        name: "Dominykas Mačiulaitis",
        position: "Data Analytic",
        img: dominykasPic,
        socials: {
            facebook: "https://www.facebook.com/profile.php?id=100004572674904",
        }
    }
];

export const Team = () => {
    return (
        <>
        <div className='container' id="TeamHeader">
            <div className='header flex text-center'>
            <h5 data-aos="fade-down" data-aos-anchor="#TeamHeader" data-aos-delay="0">The best of the best</h5>
            <h2 data-aos="fade-down" data-aos-anchor="#TeamHeader" data-aos-delay="100">Our TEAM</h2>
            <p data-aos="fade-down" data-aos-anchor="#TeamHeader" data-aos-delay="200">A group of highly-motivated professionals</p>
            </div>
        </div>
        <div id="Team">
            {teamMembers.map((member, index) => (
                <div className="team-member" key={index} data-aos="zoom-in" data-aos-delay={ifMobile? 0 : index * 100}>
                    <img src={member.img} alt={member.name} />
                    <h3>{member.name}</h3>
                    <p>{member.position}</p>
                    <div className="socials">
                        {member.socials.linkedin &&
                            <a href={member.socials.linkedin} target="_blank" rel="noreferrer">
                                <i className="fab fa-linkedin"></i>
                            </a>
                        }
                        {member.socials.website &&
                            <a href={member.socials.website} target="_blank" rel="noreferrer">
                                <i className="fas fa-globe"></i>
                            </a>
                        }
                        {member.socials.facebook &&
                            <a href={member.socials.facebook} target="_blank" rel="noreferrer">
                                <i className="fab fa-facebook"></i>
                            </a>
                        }
                    </div>
                </div>
            ))}
        </div>
        </>
    );
}